import { FunctionComponent } from 'react';

const CardFormStyles: FunctionComponent = () => {
  return(
    <style>
      {`
      /* Global
      =================== */
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        font-size: 16px;
        font-family: 'Lato', sans-serif;
      }
      
      
      /* Card Form
      =================== */
      .card-form {
        align-items: center;
        background-color: #F4F4F6;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        display: flex;
        max-width: 100%;
        height: 55px;
        padding: 0 12px;
      }
      
      .card-form-white {
        align-items: center;
        background-color: #FFFFFF;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        display: flex;
        max-width: 100%;
        height: 55px;
        padding: 0 12px;
      }
      
      .card-form:hover {
        background-color: #EEEEF5;
      }
      
      .card-form>*:not(:last-child) {
        margin-right: 4px;
      }
      
      .card-form-white>*:not(:last-child) {
        margin-right: 4px;
      }
      
      .card-form-input {
        width: 100%;
        border: none;
        background-color: transparent;
        color: rgba(0, 0, 0, 0.87);
      }
      
      .card-form-input:focus {
        outline: none;
      }
      
      .card-form-input:focus::placeholder {
        color: black;
      }
      
      
      /* Card Form Fields
      =================== */
      .card-field--number {
        flex-grow: 1;
      }
      
      .card-field--month>input {
        text-align: right;
      }
      
      .card-field--month,
      .card-field--year {
        width: 30px;
      }
      
      .card-field--cvv {
        width: 40px;
      }      
      `}
    </style>
  );
};

export default CardFormStyles;
